export default "__VITE_ASSET__C7Sfg1Wu__"